import { IPermissionsContext } from "../../ipermissions-context/ipermissions-context.interface";
import { IPermissions } from "../../ipermissions/ipermissions.interface";
import {
  hasUserGroup,
  isPageTypeExecutionBrief,
} from "../../ipermissions-context/ipermissions-context.functions";
import { UserGroup } from "../../../../../constants/types";
import { enablePermissions } from "../../ipermissions/ipermissions.functions";
import { IPermissionPolicyEvaluator } from "../../ipermissions/ipermission-policy.type";

export const workOrderManagerGroupPolicy = (next?: IPermissionPolicyEvaluator) => (
  context: IPermissionsContext,
  permissions: IPermissions
) => {
  // console.log("checkWorkOrderManagerPolicy -->");
  if (hasUserGroup(context, UserGroup.WORK_ORDER_MANAGERS)) {
    // console.log("checkWorkOrderManagerPolicy --> TRUE");

    if (isPageTypeExecutionBrief(context)) {
      enablePermissions(permissions, "manageWorkOrders");
    }
  }

  if (next) {
    return next(context, permissions);
  }
};
